"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentId = void 0;
var firestore_1 = require("firebase/firestore");
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */
var documentId = function () {
    return (0, firestore_1.documentId)();
};
exports.documentId = documentId;
